import { useEffect, useState } from "react";
import { api, type Visitor } from "@/lib/api";
import { Globe } from "lucide-react";

export function VisitorRegion() {
  const [v, setV] = useState<Visitor | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.me().then(setV).catch((e) => setErr(String(e)));
  }, []);

  if (err) return null;
  if (!v) {
    return (
      <div className="text-sm text-[var(--color-muted)] flex items-center gap-2">
        <Globe className="h-4 w-4 opacity-60" /> locating…
      </div>
    );
  }
  return (
    <div className="text-sm text-[var(--color-muted)] flex items-center gap-2">
      <Globe className="h-4 w-4 opacity-60" />
      <span>
        you’re hitting from <span className="text-[var(--color-fg)]">{v.description}</span>
        {v.fly_region_header && (
          <>
            {" "}
            via fly edge{" "}
            <span className="text-[var(--color-fg)] font-mono">{v.fly_region_header}</span>
          </>
        )}
      </span>
    </div>
  );
}
